import React from 'react';
import { Button, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const ErrorCard = styled(Grid)(({ theme, first }) => ({
  background: 'transparent',
  border: 'none',
  borderRadius: 0,
  boxShadow: 'none',
  marginBottom: 16,
  paddingTop: first ? 16 : 0,
}));

const ComponentName = styled(Grid)(({ theme }) => ({
  marginBottom: 8,
  fontWeight: 700,
}));

const ErrorMessage = styled('div')(({ theme }) => ({
  color: '#b94a48',
}));

const TriggerNotSyncContainer = styled(Grid)(({ theme }) => ({
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.custom.border}`,
  borderRadius: '10px',
  boxSizing: 'border-box',
  padding: '0px 16px 0px 16px',
  marginTop: 8,
  marginBottom: 16,
}));

const TriggerNotInSyncWarning = ({ syncStatus, projectId }) => {
  const notInSync = syncStatus.filter(s => s.status === 'NOT_IN_SYNC');
  if (notInSync.length === 0) return <></>;
  return (
    <TriggerNotSyncContainer>
      {notInSync.map((s, idx) => (
        <ErrorCard key={s.componentId} container direction="column" first={idx === 0}>
          <ComponentName item>
            <b>Component:</b> {s.componentName ? s.componentName : s.componentId}
          </ComponentName>
          <Grid item container alignItems="center" spacing={2}>
            <Grid item xs>
              {s.pipedreamSyncErrorMessage && (
                <ErrorMessage>
                  <b>Error:</b> {s.pipedreamSyncErrorMessage}
                </ErrorMessage>
              )}
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={() =>
                  window.open(`/project/canvas/${projectId}?view=${s.componentId}`, '_blank')
                }
              >
                Go to Trigger
              </Button>
            </Grid>
          </Grid>
        </ErrorCard>
      ))}
    </TriggerNotSyncContainer>
  );
};

export default TriggerNotInSyncWarning;
